import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import styled from "styled-components";

import { FlagsTab } from "./FlagsTab";

const ConsoleLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ConsoleCard = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 49, 0.05);
  padding: 32px;
`;

/**
 * The superuser Feature Flags admin tool, cloned in structure from
 * EdnitionAdminConsole (react-bootstrap Tabs/Tab). One tab today — Flags —
 * which lists flags, creates new ones, toggles active/default, and manages a
 * flag's per-subject targets in a modal. Every backend call goes through
 * request() from useOkoApi (Firebase bearer auto-attached); access is enforced
 * by the superuser-guarded /admin/feature-flags endpoints, not a menu boolean.
 */
export const FeatureFlagsAdminConsole = () => {
  const [activeTab, setActiveTab] = useState("flags");

  return (
    <ConsoleLayout className="feature-flags-admin-console">
      <ConsoleCard>
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          <Tab eventKey="flags" title="Flags">
            <FlagsTab />
          </Tab>
        </Tabs>
      </ConsoleCard>
    </ConsoleLayout>
  );
};
